export function useAccessToken() {
	const internalAccessToken: Ref<string | undefined> = ref(undefined)
	const getAccessToken = async (): Promise<string> => {
		const response = (await $fetch("/api/auth/token")) as { accessToken?: string }
		if (response?.accessToken) {
			internalAccessToken.value = response.accessToken
			return response.accessToken
		}

		throw new Error("Access token not available")
	}

	return {
		getAccessToken,
		accessToken: readonly(internalAccessToken)
	}
}
